import React from 'react';
import { PAGE_ROUTE } from '../../lib/routes';
import { Logo } from './Logo';
interface FooterProps {
  navigate: (page: string) => void;
}
export function Footer({
  navigate
}: FooterProps) {
  const currentYear = new Date().getFullYear();
  return <footer className="border-t border-dark-4 bg-dark-1" data-id="element-2154">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2155">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-2156">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-2157">
            <button onClick={() => navigate(PAGE_ROUTE.HOME)} className="flex items-center gap-2 cursor-pointer" aria-label="Izio" data-id="element-2158">
              <Logo className="h-7 w-auto" data-id="element-2159" />
            </button>
            <p className="text-sm text-light-3 mt-3 max-w-xs" data-id="element-2160">
              Platforma unde chiriile aplică la chiriași. Inversăm procesul de
              închiriere.
            </p>
          </div>

          {/* Platform */}
          <div data-id="element-2161">
            <h4 className="font-semibold text-sm text-light-1 mb-4" data-id="element-2162">
              Platformă
            </h4>
            <ul className="space-y-2.5" data-id="element-2163">
              <li data-id="element-2164">
                <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2165">
                  Marketplace
                </button>
              </li>
              <li data-id="element-2166">
                <button onClick={() => navigate(PAGE_ROUTE.ONBOARDING)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2167">
                  Creează profil
                </button>
              </li>
              <li data-id="element-2168">
                <button onClick={() => navigate(PAGE_ROUTE.DASHBOARD)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2169">
                  Autentificare
                </button>
              </li>
              <li data-id="element-2170">
                <button onClick={() => navigate(PAGE_ROUTE.TEASING)} className="text-sm text-light-1 hover:text-lime-1 transition-colors cursor-pointer inline-flex items-center gap-1.5 font-medium" data-id="element-2171">
                  Beta
                  <span className="bg-lime-1 text-dark-1 text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-2172">
                    NEW
                  </span>
                </button>
              </li>
            </ul>
          </div>

          {/* For Landlords */}
          <div data-id="element-2173">
            <h4 className="font-semibold text-sm text-light-1 mb-4" data-id="element-2174">
              Pentru proprietari
            </h4>
            <ul className="space-y-2.5" data-id="element-2175">
              <li data-id="element-2176">
                <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2177">
                  Caută chiriași
                </button>
              </li>
              <li data-id="element-2178">
                <span className="text-sm text-light-4" data-id="element-2179">Cum funcționează</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-2180">
            <h4 className="font-semibold text-sm text-light-1 mb-4" data-id="element-2181">Legal</h4>
            <ul className="space-y-2.5" data-id="element-2182">
              <li data-id="element-2183">
                <button onClick={() => navigate(PAGE_ROUTE.TERMENI)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2184">
                  Termeni si conditii
                </button>
              </li>
              <li data-id="element-2185">
                <button onClick={() => navigate(PAGE_ROUTE.CONFIDENTIALITATE)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2186">
                  Politica de confidentialitate
                </button>
              </li>
              <li data-id="element-2187">
                <button onClick={() => navigate(PAGE_ROUTE.CONTACT)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-2188">
                  Contact
                </button>
              </li>
              <li data-id="element-2189">
                <button className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer" onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-preferences'))} data-id="element-2190">
                  Setări cookie-uri
                </button>
              </li>
              <li data-id="element-2191">
                <button onClick={() => navigate(PAGE_ROUTE.CHANGELOG)} className="text-sm text-light-3 hover:text-light-1 transition-colors cursor-pointer inline-flex items-center gap-1.5" data-id="element-2192">
                  Changelog
                  <span className="text-[10px] font-mono text-light-4 border border-dark-4 px-1 py-0.5 rounded" data-id="element-2193">
                    v132
                  </span>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-dark-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-2194">
          <p className="text-sm text-light-4" data-id="element-2195">
            © {currentYear} Izio. Toate drepturile rezervate.
          </p>
          <div className="flex items-center gap-4" data-id="element-2196">
            <span className="text-xs text-light-4" data-id="element-2197">Făcut cu ❤️ în România</span>
          </div>
        </div>
      </div>
    </footer>;
}